import { createSlice } from "@reduxjs/toolkit";
import { EstablishmentInterface } from "../../common/interfaces/EstablishmentInterface";

interface EstablishmentsPageInterface {
    isConformationModalOpen: boolean;
    establishment?: EstablishmentInterface;
    searchTerm: string;
}

const initialState: EstablishmentsPageInterface = {
    isConformationModalOpen: false,
    searchTerm: "",
};

const establishmentsSlice = createSlice({
    name: "establishments",
    initialState,
    reducers: {
        setIsConformationModalOpen: (state, action) => {
            state.isConformationModalOpen = action.payload;
        },
        setEstablishment: (state, action) => {
            state.establishment = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
    },
});

export const establishmentsReducer = establishmentsSlice.reducer;

export const { setIsConformationModalOpen, setEstablishment, setSearchTerm } =
    establishmentsSlice.actions;
